import { useId } from "react";
import { trpc } from "../../lib/trpc";
import { SearchSelect } from "./SearchSelect";

/** "Global" seçimi için sentinel (backend'e null gider = tüm tesisler görür). */
export const GLOBAL_TESIS = "__global__";

/**
 * Ana veri (kart/reçete/cari) create'inde tesis seçimi.
 * YALNIZCA süper-admin + "Tüm Tesisler" (activeFacilityId=null) + create modunda görünür.
 * Diğer durumlarda backend otomatik damgalar (tesisli kullanıcı→kendi tesisi; süper-admin-scoped→aktif tesis).
 */
export function useTesisPicker(isCreate: boolean) {
  const meQ = trpc.auth.me.useQuery(undefined, { staleTime: 5 * 60_000 });
  const u = meQ.data?.user;
  const show = isCreate && !!u?.isSuperAdmin && !u?.activeFacilityId;
  return { show, facilities: u?.facilities ?? [] };
}

/** Seçilen değeri (id / GLOBAL_TESIS / "") backend tesisId'sine çevir: Global→null, boş→undefined, diğer→id. */
export function resolveTesisId(show: boolean, value: string): string | null | undefined {
  if (!show) return undefined; // backend otomatik damgalar
  return value === GLOBAL_TESIS ? null : value;
}

interface Props {
  show: boolean;
  facilities: Array<{ id: string; code: string; name: string }>;
  value: string;
  onChange: (v: string) => void;
}

export function TesisPickerField({ show, facilities, value, onChange }: Props) {
  /**
   * Etiket–alan bağı: `<label>` ne htmlFor taşıyordu ne de kontrolü sarmalıyordu,
   * yani ekran okuyucu bu ZORUNLU alanın adını hiç duyurmuyor ve etikete tıklamak
   * hiçbir şey yapmıyordu. id SABİT OLAMAZ: aynı anda birden çok örnek mount
   * olabiliyor (sekmeler keep-alive) — sabit id belgede çakışır ve etiket yanlış
   * örneğe bağlanır. Hook koşullu return'den ÖNCE çağrılmalı.
   */
  const uid = useId();
  if (!show) return null;
  const fieldId = `${uid}-tesis`;
  const opts = [
    { value: GLOBAL_TESIS, label: "Global (Tüm Tesisler)", desc: "tüm tesisler görür" },
    ...facilities.map((f) => ({ value: f.id, label: f.name, desc: f.code })),
  ];
  return (
    <div className="form-field">
      <label className="lbl" htmlFor={fieldId}>Tesis <span className="req">*</span></label>
      <SearchSelect id={fieldId} value={value || null} options={opts} onChange={(v) => onChange(v ?? "")} icon="building" placeholder="Tesis seç…" searchPlaceholder="Tesis ara…" emptyText="Tesis yok" />
      <span style={{ fontSize: 11, color: "var(--neutral-500)", marginTop: 2 }}>Bu kayıt yalnız seçilen tesiste görünür (Global = tüm tesisler).</span>
    </div>
  );
}
